import { ContactAddress } from "services/api/contacts/types";

/**
 * Adresa kontakta u jedan redak, kakav stoji na računu. Prazni dijelovi otpadaju da ne ostanu
 * zarezi bez sadržaja.
 */
export const buildContactAddress = (address: ContactAddress | null): string | null => {
  if (!address) return null;

  const street = [address.line1, address.line2].filter(Boolean).join(" ").trim();
  const city = [address.postalCode, address.city].filter(Boolean).join(" ").trim();
  const parts = [street, city].filter(part => part.length > 0);

  return parts.length > 0 ? parts.join(", ") : null;
};
